import getLibrary from "./getLibrary";

export const useWeb3 = getLibrary;
